// extracted by mini-css-extract-plugin
module.exports = {"map":"about-module--map--2Sm8H","controlPanel":"about-module--control-panel--1jgMN"};